<template>
  <div class="page page-system">
    <div
      class="page__wrap"
      data-animate="page-wrap"
      :class="{
        'p-bot-3': count > limit,
      }"
    >
      <header class="row-1 p-top-3">
        <!-- Title -->
        <div class="row-1">
          <h1 data-animate="header-title" class="title-m">
            {{ $t('listing.systems') }}
          </h1>
        </div>
      </header>

      <ListingRowsList
        class="row-1 m-top-3"
        :class="{
          'p-bot-3': count <= limit,
        }"
        :items="formattedFamily"
      />
    </div>
  </div>
</template>

<script setup>
import { useCraftStore } from '@/store/craft.js'
import queries from '@/graphql/craft/queries/index.js'

import {
  onBeforeEnter,
  onEnter,
  onLeave,
} from '~/assets/js/page-transitions/listing.js'

definePageMeta({
  layout: 'default',
  pageTransition: {
    onBeforeEnter: (el) => {
      onBeforeEnter(el)
    },
    onEnter: async (el, done) => {
      const tl = onEnter(el, done)
      await tl.delay(0.75).play()
      done()
    },

    onLeave: async (el, done) => {
      const tl = onLeave(el)
      await tl.play()
      window.lenis.scrollTo(0, { immediate: true })
      done()
    },
  },
})

// Fetch Craft
const { configuration } = useCraftStore()
const route = useRoute()

// Fetch Data
const query = queries.typologies.getTypology
const key = 'sistema'
const keyId = [162, 160] // metto sia sistemi che collezioni dato che ora possono selezionar eanche i prodotti singoli
const type = 'family'

const limit = ref(500)

const variables = computed(() => ({
  site: configuration.site,
  marketId: configuration.marketId,
  typologyId: keyId,
  typologyKey: key,
  type,
  isSystem: true,
  limit: limit.value,
  offset: route.query?.page
    ? (parseInt(route.query?.page) - 1) * limit.value
    : 0,

  // lineId: configuration.lineId('decorative'),
}))
const { data } = await useGraphql(query, variables)
const families = computed(() => data.value?.productsEntries || [])
/*watch(
  () => families.value,
  (families) => {
    if (!families.length) {
      throw createError({ statusCode: 404 })
    }
  },
  {
    immediate: true,
  }
)
*/
const count = computed(() => data.value?.entryCount || 0)

const seo = computed(() => data.value?.entry?.seo || {})

const formattedFamily = computed(() => {
  return families.value
    .map((family) => {
      //largeItem mi indica se nel listing il prodotto occupa più spazi
      return {
        title: family.title,
        cover: family.coverPortrait?.[0] || family.cover?.[0],
        route: {
          name: 'product-family-slug',
          params: { slug: family.slug },
        },
        children: family.children.map((child) => {
          return {
            ...child,
            route: {
              name: 'product-slug',
              params: { slug: child.slug },
            },
          }
        }),
      }
    })
    .filter((family) => family.children.length > 0)
})

// Seo
useSeo({
  ...seo.value,
  meta: [
    {
      name: 'description',
      content: seo.value?.description,
    },
  ],
})
</script>
